import CRUD from '../masterData/genericCRUD'

const route = 'grower_estimates/variety_estimates'

/**
 * @param {import("axios").AxiosInstance} instance
 */
export default function estimates(instance) {
	return {
		/**
		 * CRUD creates the Create, Get, Update and GetALL endpoints;
		 */
		...CRUD(instance, route),
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getAllByFarm: (id, config = {}) => {
			return instance.get(`grower_estimates/${id}/variety_estimates`, config)
		},
		/**
		 * @param {number} id
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		getVarieties: (id, config = {}) => {
			return instance.get(`grower_estimates/${id}/varieties`, config)
		},
		/**
		 * @param {number} id
		 * @param {{ name: string }} body
		 * @param {import("axios").AxiosRequestConfig} config
		 */
		create: (id, body, config = {}) => {
			return instance.post(
				`grower_estimates/${id}/variety_estimates`,
				body,
				config
			)
		}
	}
}
